import { createContext, useContext } from 'solid-js';
import { createStore } from 'solid-js/store';
const [state, setState] = createStore({ map: null });
export const MapContext = createContext([state]);
export const useMapContext = () => useContext(MapContext);
export const MapProvider = (props) => {
    props.map && setState('map', props.map);
    return (<MapContext.Provider value={[state]}>{props.children}</MapContext.Provider>);
};
